import React from "react";
import { ContactAsSection } from "../components/ContactAsSection/ContactAsSection";
import Section from "../components/Section/Section";
import { useTranslation } from "react-i18next";
import AsideNav from "../components/AsideNav/AsideNav";
import { headerNavigationConstants } from "../constants/navigationConstants";
import { HeroImage } from "../components/Image/Image.styled";

const ServicePage: React.FC<{ i18nKey?: string }> = ({ i18nKey }) => {
  const { t } = useTranslation();

  const page = headerNavigationConstants
    .filter((x) => x.dropdown)
    .flatMap((category) => category.dropdown ?? [])
    .find((item) => item.i18nKey === i18nKey);
  return (
    <>
      <HeroImage
        src={page?.imageUrl}
        alt={page?.title}
        $position={page?.heroImagePosition}
      />
      <Section
        withBackgroundImg={false}
        header={i18nKey ? t(`${i18nKey}.title`) : ""}
        textKey={`${i18nKey}.text`}
        asideContent={<AsideNav />}
      ></Section>
      <ContactAsSection />
    </>
  );
};

export default ServicePage;
